module.exports = __webpack_public_path__ + "img/fastcharger-realized.ba7777b5.png";